export default __webpack_public_path__ + "static/media/Exclamation_result_02.b071cc21.png";